import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { LEGAL_PAGES } from "../data/legal";
import { Seo } from "../components/Seo";

export default function LegalPage({ slug }) {
  const page = LEGAL_PAGES[slug];
  return (
    <main className="pt-[76px] min-h-screen" data-testid={`legal-page-${slug}`}>
      <Seo title={`${page.title} | Salgin Solutions`} description={`${page.title} von Salgin Solutions – professionelle KI-Bilder & Skizzen, Bad Oeynhausen.`} path={`/${slug}`} />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28 grid lg:grid-cols-12 gap-12">
        <aside className="lg:col-span-4">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[var(--muted)] hover:text-[var(--gold)] transition-colors" data-testid="legal-back-link">
            <ArrowLeft size={14} /> Zurück zur Startseite
          </Link>
          <p className="eyebrow mt-10 mb-4">{page.eyebrow}</p>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02]"
            data-testid="legal-title"
          >
            {page.title}
          </motion.h1>
          <p className="mt-6 font-mono text-[0.65rem] tracking-[0.2em] uppercase text-[var(--muted-2)]">Stand: {page.date}</p>
          <nav className="mt-12 hidden lg:block border-l border-[var(--line)] pl-5 space-y-3">
            {Object.entries(LEGAL_PAGES).map(([s, p]) => (
              <Link key={s} to={`/${s}`} className={`block text-sm transition-colors ${s === slug ? "text-[var(--gold)]" : "text-[var(--muted)] hover:text-[var(--text)]"}`} data-testid={`legal-nav-${s}`}>
                {p.title}
              </Link>
            ))}
          </nav>
        </aside>
        <motion.article
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
          className="lg:col-span-7 lg:col-start-6 legal"
          data-testid="legal-content"
          dangerouslySetInnerHTML={{ __html: page.html }}
        />
      </div>
    </main>
  );
}
